export default __webpack_public_path__ + "static/media/world.8731ac28.png";